import { getAuth } from "firebase/auth";

export function openOAuthPopup(
  clientId: string,
  onSuccess: () => void,
  onError: (error: string) => void
) {
  const user = getAuth().currentUser;
  if (!user) {
    onError("User must be logged in");
    return;
  }

  const redirectUri = `${window.location.origin}/oauth/callback`;
  const authUrl = new URL("https://accounts.google.com/o/oauth2/v2/auth");
  authUrl.searchParams.set("client_id", clientId);
  authUrl.searchParams.set("redirect_uri", redirectUri);
  authUrl.searchParams.set("response_type", "code");
  authUrl.searchParams.set(
    "scope",
    "https://www.googleapis.com/auth/firebase https://www.googleapis.com/auth/cloud-platform"
  );
  authUrl.searchParams.set("access_type", "offline");
  authUrl.searchParams.set("prompt", "consent");
  authUrl.searchParams.set("state", user.uid);
  authUrl.searchParams.set("login_hint", user.email ?? "");

  const width = 500;
  const height = 600;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  const popup = window.open(
    authUrl.toString(),
    "oauth_popup",
    `width=${width},height=${height},left=${left},top=${top}`
  );

  if (!popup) {
    onError("Please allow popups for this site");
    return;
  }

  let isResolved = false;

  const messageHandler = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;
    if (isResolved) return;

    if (event.data.type === "OAUTH_SUCCESS") {
      isResolved = true;
      window.removeEventListener("message", messageHandler);
      onSuccess();
    } else if (event.data.type === "OAUTH_ERROR") {
      isResolved = true;
      window.removeEventListener("message", messageHandler);
      let message = "An error occurred during authorization";
      if (event.data.error === "access_denied") {
        message = "Authorization denied";
      } else if (event.data.error === "popup_closed_by_user") {
        message = "Authorization cancelled";
      }
      console.log("message", message);
      onError(message);
    }
  };

  window.addEventListener("message", messageHandler);

  // Set a timeout to clean up if no response
  setTimeout(() => {
    if (!isResolved) {
      window.removeEventListener("message", messageHandler);
      onError("Authorization timed out");
    }
  }, 5 * 60 * 1000); // 5 minutes timeout

  // Remove the popup.closed check entirely
  // Just rely on postMessage
}
